import { Component, OnInit, Input, Injector } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-counselling-package-detailing',
    templateUrl: './counselling-package-detailing.component.html',
    standalone: false
})
export class CounsellingPackageDetailingComponent extends MainComponent implements OnInit {
  @Input() data: any;
  currentData: any = {};

   fields=[];
  id: String;
//   billingCategoryId: String;
//   payerId: String;
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
  ) {super(injector, route); }

  ngOnInit() {
    console.log("Data ", this.data);
    if(this.data!= null){
        this.id = this.data.id;

    }
    
    this.currentData.showView = false;
    this.getOrders();
  }
  getOrders(){
    let data = {
      "args":"uhId:" + this.data.uhId + ",id:" + this.data.id,
      "query_id": "GET_BY_ID",
    }
    this.baseService.getData(data, "", 'counselling_detail', 'adt', 'GET_BY_ID').subscribe(
      result => {
        if(result.errCode == 0 && result.resource.length > 0){
          if(result.resource[0].package_data.length > 0){
            result.resource[0].package_data.filter(x=>this.fields.push(x.package_id));
            this.currentData.filterData = result.resource[0].package_data;
            this.currentData.showView = true;
            console.log("Filter Data ", this.currentData.filterData);
          }
        }else{
        }
    });
  }
  handleFile(args, obj, callback = null) {
    this.loader.showSpinner();
    var fileObj = {
      "application": "adt",
      "template": "counsellingpackagedetailing",
      "resource": "counselling_detail",
      "contentType": "pdf",
      "args": args,
      "file_type": "pdf",
      "queryId": 'print'
    }
    this.baseService.handleFile(fileObj, (fileData) => {
      if (fileData) {
        fileObj['key'] = obj.id;
        this.printService.handleFileReponse(fileObj, 'print', fileData, callback);
      } else {
        this.alerts.error('server error');
        if (callback) {
          callback(false);
        }
      }
      this.loader.hideSpinner();
    }, (error) => {
      this.loader.hideSpinner();
      this.alerts.error('server error');
      if (callback) {
        callback(false);
      }
    });
  }
  valueChange(data){
    let args: any;
    // console.log("Data is ", data);
    this.currentData.selectedData = data;
    if(this.currentData.selectedData!=undefined){
       args = "package_id:"+this.currentData.selectedData.package_id+",id:"+this.id+",reportTemplateId:counsellingpackagedetailing"
    
    }
    this.handleFile(args, this.data, (res) => {
      if (!res) {
        this.alerts.error("Print Error");
      } else {
        //this.dialogRef.close();
      }
    });
  }
  isRadioSelected(id){
    if(this.currentData.selectedData != undefined)
      return (this.currentData.selectedData.id == id);
    else
    return false;
  }
}
